module.exports = __webpack_public_path__ + "static/media/Classifier.11712d24.mp4";